import axios from './axiosInstance';

class PaginatedComponent {

    constructor ({
        current_page,
        data,
        dataParser = list => list,
        filters = {},
        first_page_url,
        from,
        last_page,
        last_page_url,
        loadingAction,
        next_page_url,
        pageAccessor = page => page,
        parsed = false,
        per_page,
        prev_page_url,
        setAction,
        to,
        total
    }) {
        this.current_page = current_page;
        this.data = parsed ? data : dataParser(data);
        this.dataParser = dataParser;
        this.filters = filters;
        this.first_page_url = first_page_url;
        this.from = from;
        this.last_page = last_page;
        this.last_page_url = last_page_url;
        this.loadingAction = loadingAction;
        this.next_page_url = next_page_url;
        this.pageAccessor = pageAccessor;
        this.per_page = per_page;
        this.prev_page_url = prev_page_url;
        this.setAction = setAction;
        this.to = to;
        this.total = total;
    }

    findItem = (accessor, toFind) => {
        if (typeof accessor === 'function') {
            return this.data.find(accessor);
        }
        if (typeof accessor === 'string') {
            return this.data.find(elem => elem[accessor] === toFind);
        }
        return undefined;
    };

    getData = () => ({
        currentPage: this.current_page,
        data: this.data,
        filters: this.filters,
        lastPage: this.last_page,
        perPage: this.per_page,
        showingFrom: this.from,
        showingTo: this.to,
        totalElements: this.total
    });

    getPage = async url => {
        if (!!url) {
            const { store } = await import('./store.config');
            try {
                store.dispatch(this.loadingAction(true));
                const newUrl = url.slice(0, 5) !== 'https' ? url.replace('http', 'https') : url;
                const { data: result } = await axios.get(newUrl, { params: this.filters });
                const { data: fetchData } = this.pageAccessor(result);
                const { data = [] } = fetchData;
                store.dispatch(this.setAction({
                    ...fetchData,
                    data: this.dataParser(data),
                    filters: this.filters,
                    parsed: true
                }));
            } catch (e) {

            } finally {
                store.dispatch(this.loadingAction(false));
            }
        }
    };

    getFirstPage = () => this.getPage(this.first_page_url);
    getLastPage = () => this.getPage(this.last_page_url);
    getNextPage = () => this.getPage(this.next_page_url);
    getPrevPage = () => this.getPage(this.prev_page_url);

    removeItem = (accessor, toFind) => {
        const findFunction = typeof accessor === 'function' ? accessor : elem => elem[accessor] === toFind;
        const itemIndex = this.data.findIndex(findFunction);
        if (itemIndex < 0) return;
        this.data.splice(itemIndex, 1);
    };

    replaceItem = (accessor, toFind, newItem) => {
        const findFunction = typeof accessor === 'function' ? accessor : elem => elem[accessor] === toFind;
        const itemIndex = this.data.findIndex(findFunction);
        if (itemIndex < 0) return;
        this.data[itemIndex] = newItem;
    };

}

export default PaginatedComponent;
